import { html, render } from "lit-html";
import Random from "rung/src/random";
import TextGrid from "overprint/overprint/text-grid";
import Font from "overprint/overprint/font";
import Glyphs from "../assets/objects/glyphs";
import Directions from "../engine/directions";
import Input from "../engine/input";
import { Commands } from "../engine/commands";

const rng = new Random(Math.random);

class TitleScreen {
  constructor() {
    this.container = document.querySelector(".title");
    this.canvas = document.querySelector(".game-stage");

    this.width = 80;
    this.height = 50;
    
    this.camera = {
      x: 120,
      y: 80
    }
    
    this.splashCounter = 50;
    this.isScrolling = true;
    this.scrollDirection = Directions.ALL[rng.integer(0, 8)];

    this.rescale();
  }

  activate() {
    document.body.classList.add("is-title");
    this.container.classList.add("is-visible");
    render(this.getTitleCard(), this.container);
    this.activateNavFocus();
    this.rescale();
  }

  deactivate() {
    this.container.classList.remove("is-visible");
    this.grid.clear();
  }

  activateNavFocus() {
    this.focusedButton = 0;
    this.nav = this.container.querySelectorAll(".title-card nav button");
    this.nav[this.focusedButton].focus();
  }

  nextNavFocus() {
    this.focusedButton = (this.focusedButton + 1) % this.nav.length;
    this.nav[this.focusedButton].focus();
  }

  prevNavFocus() {
    this.focusedButton = ((this.focusedButton - 1) + this.nav.length) % this.nav.length;
    this.nav[this.focusedButton].focus();
  }

  handleInput(input, stage) {
    switch (input) {
      case Input.MoveDown:
      case Input.MoveRight:
      case Input.FocusRight:
        this.nextNavFocus();
        break;
      case Input.MoveUp:
      case Input.MoveLeft:
      case Input.FocusLeft:
        this.prevNavFocus();
        break;
      case Input.Ok:
        this.nav[this.focusedButton].blur();
        return this.selectMenuButton(this.nav[this.focusedButton]);
    }
  }

  handleClick(ev, stage) {
    return this.selectMenuButton(ev.target);
  }

  handleRightClick(ev, stage) {
    // TODO: something with scrolling the map maybe
  }

  selectMenuButton(el) {
    if (process.env.IS_DESKTOP) {
      if (el.matches(".button-quit")) {
        window.desktopApp.quit();
        return;
      }
    }

    if (el.matches(".button-new")) {
      return Commands.StartGame;
    } else if (el.matches(".button-controls")) {
      return Commands.ShowControls;
    } else if (el.matches(".button-credits")) {
      return Commands.ShowCredits;
    } else {
      return false;
    }
  }

  get viewportFontSize() {
    //return Math.round(this.viewportWidth / 90 * 1.5 + 1);
    return Math.round(this.viewportWidth / 96);
  }

  rescale() {
    this.viewportWidth = document.documentElement.clientWidth;
    this.grid = new TextGrid(this.canvas, {
      width: this.width,
      height: this.height,
      emptyCell: Glyphs.Void,
      font: Font("JuliaMono", false, this.viewportFontSize)
    });
  }

  renderMap(stage) {
    for (let y=0; y < this.height; y++) {
      for (let x=0; x < this.width; x++) {
        let tileType = Glyphs.Empty;
        let cx = x + this.camera.x;
        let cy = y + this.camera.y;
        this.grid.writeCell(x, y, Glyphs.UNLIT[stage.map[cy][cx].name]);
      }
    }
  }

  moveCamera(stage) {
    if (this.splashCounter <= 0) {
      this.isScrolling = !this.isScrolling;
      this.splashCounter = this.isScrolling ? rng.integer(50, 150) : 400;
      this.scrollDirection = Directions.ALL[rng.integer(0, 8)];
      return;
    } else {
      this.splashCounter--;
    }
    if (this.isScrolling) {
      this.camera.x = Math.min(
        Math.max(80, this.camera.x + this.scrollDirection.x),
        stage.width - 100
      );
      this.camera.y = Math.min(
        Math.max(62, this.camera.y + this.scrollDirection.y),
        stage.height - 250
      );
    }
  }

  getTitleCard() {
    return html`
      <div class="title-card">
        <h1>Caldera</h1>
        <nav>
          <button class="button-new">New Game</button>
          <button class="button-controls">Controls</button>
          <button class="button-credits">Credits</button>
          ${process.env.IS_DESKTOP ? html`<button class="button-quit">Quit</button>` : ''}
        </nav>
      </div>
    `;
  }

  render(stage) {
    this.moveCamera(stage);

    this.renderMap(stage);
    this.grid.render();
  }
}

export default TitleScreen;
